// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__+4MJ1","black":"siteholder_black__S-ZKs","white":"siteholder_white__p9nbs","img":"siteholder_img__ZD-+U","zoomin":"siteholder_zoomin__MnRjO"};